import { render, staticRenderFns } from "./new-group.vue?vue&type=template&id=472d852a&"
import script from "./new-group.vue?vue&type=script&lang=js&"
export * from "./new-group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports